import React from 'react';
import { Box, CircularProgress, Paper, Typography } from '@mui/material';

export const CheckingCommercialAgreements: React.FC = () => {
  return (
    <Box
      component={Paper}
      elevation={1}
      variant="outlined"
      sx={(t) => ({
        zIndex: 1,
        p: 1,
        mb: 2,
        display: 'flex',
        flexDirection: 'row',
        position: 'sticky',
        top: 0,
        border: `1px solid ${t.palette.divider}`,
      })}
    >
      <CircularProgress size={20} sx={{ height: 40, width: 40 }} />

      <Typography sx={{ ml: 1 }} variant="body2">
        Checking commercial agreements.
      </Typography>
    </Box>
  );
};
